import { render, staticRenderFns } from "./CameraModal.vue?vue&type=template&id=35a5ccb2&scoped=true"
import script from "./CameraModal.vue?vue&type=script&lang=ts"
export * from "./CameraModal.vue?vue&type=script&lang=ts"
import style0 from "./CameraModal.vue?vue&type=style&index=0&id=35a5ccb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a5ccb2",
  null
  
)

export default component.exports